import {
  Container,
  Skeleton,
  Typography,
} from "@mui/material";

import { useApiKeysQuery } from "~/graphql/__generated__/graphql";
import WebhookEndpoints from "./WebhookEndpoints";

const TabApiKeys = () => {
  const { data, loading, error } = useApiKeysQuery();

  if (error) {
    return <Typography color="error">Error loading webhooks</Typography>;
  }

  return <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
    {loading ? <>
      <Skeleton width="100%" height={75} />
      <Skeleton width="100%" />
      <Skeleton width="100%" />
      <Skeleton width="100%" />
    </> : <WebhookEndpoints apiKeys={data?.apiKey || []} webhookEndpoints={data?.webhookEndpoint || []}/>}
  </Container>;
};

export default TabApiKeys;
